/**
 * Created by Ning Jiang on 2021-06-29.
 */

import {WinPresentationController} from "../WinPresentationController";
import {gsap} from "gsap";
import {Karen} from "../../Karen";
import {TimelineLite} from "gsap/gsap-core";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {Translation} from "../../../core/utils/Translation";
import {ScatterAnimation} from "../../view/ScatterAnimation";
import {KarenReelController} from "../../reels/KarenReelController";
import {KarenSoundManager} from "../../sound/KarenSoundManager";
import {KarenSoundConfig} from "../../sound/KarenSoundConfig";

export class BreakBankController extends WinPresentationController {

    constructor() {
        super("BreakBankController", true);
    }

    protected hasWin(): boolean {
        return Karen.model.parsedGameData.brokeTheBank;
    }

    protected skip() {
        KarenSoundManager.playSoundEffect(KarenSoundConfig.STOP_REEL);
        Karen.winCapScreen.setCountupEffect();
        this._flowStateController.setSkipCallback(() => this.skip());
    }

    protected async createWinAnimation(): Promise<any> {
        this._flowStateController.setSkipCallback(() => this.skip());
        const tl: TimelineLite = gsap.timeline();
        let delay: number = 0.1;
        if (Karen.model.parsedGameData.singleWin > 0) {
            delay += 0.3;
        }
        tl.to(this, {duration: delay});
        const scattr: ScatterAnimation = new ScatterAnimation("scatter");
        scattr.stopScatterWin();
        await Promise.resolve(tl);
        await new Promise<void>(resolve => {
            tl.add(Karen.winCapScreen.showAnimation(() => {
                Karen.keypadPlugin.setZeroBetSpinCounter(-1);
                resolve();
                this.close();
            }));
            tl.add(() => {
                this._flowStateController.setSkipCallback();
            });
        });
    }

    protected close(): TimelineLite {
        const tl: TimelineLite = gsap.timeline();
        tl.add(gsap.to(this, {duration: 0.01, alpha: 0}));
        tl.add(() => {
            Karen.reel2Frame.updateMode(GameMode.NORMAL);
            Karen.stickyXWView.hideAllStickyXW();
            Karen.background.updateBackGround(GameMode.NORMAL);
            Karen.reels.forEach((reel: KarenReelController) => {
                reel.changeReelSet("BASE_REELSET")
            });
        });
        return tl;
    }
}
